// extracted by mini-css-extract-plugin
export default {"container":"Overview_container__h-Jo9","label":"Overview_label__6ZlQb","tag":"Overview_tag__dCYoM"};